import React, { useCallback, useEffect } from 'react';
import apiCalls from 'src/api/apiCalls';
import CollapseData from './collapsedata';

const AdminDocuments = ({ documents, dispatch, caseData }) => {
    const [documentStates, setDocumentStates] = React.useState({});
    useEffect(() => {
        if (documents?.[0]) {
            handleCaseReplies(documents?.[0]?.id)
        }
    }, [])
    const handleCaseReplies = useCallback(async (id) => {
        try {
            const response = await apiCalls.getDocumentReplies(id);
            if (response.ok) {
                setDocumentStates((prev) => ({
                    ...prev,
                    [id]: { loading: false, repository: response.data },
                }));
            } else {
                setDocumentStates((prev) => ({
                    ...prev,
                    [id]: { loading: false, repository: [] },
                }));
                dispatch({
                    type: "SET_ERROR",
                    payload: apiCalls.isErrorDispaly("Error fetching case data"),
                });
            }
        } catch (error) {
            setDocumentStates((prev) => ({
                ...prev,
                [id]: { loading: false, repository: [] },
            }));
            dispatch({
                type: "SET_ERROR",
                payload: apiCalls.isErrorDispaly(error.message),
            });
        }
    }, [dispatch, apiCalls]);
    return <div className='admin-document'>
        <CollapseData
            docRepository={documentStates?.[documents?.[0]?.id]?.repository}
            docunetDetailId={documents?.[0]?.id}
            state={documents?.state}
            caseData={caseData}
        />
    </div>
};

export default AdminDocuments;
